export default __webpack_public_path__ + "static/media/person3@2x.ed17092c.jpg";